import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";

const UploadService = {

    uploadFile: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("table", "Uploaded");
        formData.append("field", "Files");
        formData.append("clientType", 1);
        formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
        formData.append("fileData", file);

        ApiService.post("/common/file/upload", formData, successCallback, failureCallback);
    },

};

export default UploadService;
